import React, { Component } from 'react';
import Moment from 'moment';
import { connect } from 'react-redux';
import humanizeString from 'humanize-string';
import _ from 'lodash';

import RefreshIndicator from 'material-ui/RefreshIndicator';
import Avatar from 'material-ui/Avatar';
import TextField from 'material-ui/TextField';
import SendBtn from 'material-ui/svg-icons/content/send';
import MoreIcon from 'material-ui/svg-icons/navigation/more-vert';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import Badge from 'material-ui/Badge';
import IconButton from 'material-ui/IconButton';
import NotificationsIcon from 'material-ui/svg-icons/social/notifications';
import { green500 } from 'material-ui/styles/colors';
import Menu from 'material-ui/Menu';
import MenuItem from 'material-ui/MenuItem';
import Popover from 'material-ui/Popover';
import Dialog from 'material-ui/Dialog';
import RaisedButton from 'material-ui/RaisedButton';
import Snackbar from 'material-ui/Snackbar';
import Chip from 'material-ui/Chip';
import CancelIcon from 'material-ui/svg-icons/navigation/cancel';
import { List, ListItem, makeSelectable } from 'material-ui/List';
import { Card, CardHeader, CardText } from 'material-ui/Card';
import { Col } from 'react-bootstrap';
import validator from 'validator';
import { blue300 } from 'material-ui/styles/colors';
import { red500 } from 'material-ui/styles/colors';
import FlatButton from 'material-ui/FlatButton';

import DateRangeIcon from 'material-ui/svg-icons/action/date-range';
import DeleteIcon from 'material-ui/svg-icons/action/delete'
import ImageTimer from 'material-ui/svg-icons/image/timer';
import ActionInfo from 'material-ui/svg-icons/action/info';

import Carousel from '../carousel';
import InfiniteScroll from '../infinite-scroll';

import jsonParse from '../../utils/json-parse';
import arrayLoop from '../../utils/loop';
import format from '../../utils/format';
import imagePlaceholder from '../../utils/placeholder';
import mixpanel from '../../utils/mixpanel';

import session from '../../utils/session';

import inboxRsc from '../../reducers/inbox/resources';
import { deleteScheduledMessage} from '../../reducers/scheduled-messages/resources'
import { getModuleGroups, getModuleGroupsByCompany, getDefaultCalendarModuleGroups } from '../../reducers/modules/resources';
import { checkUserGroupDefault } from '../../reducers/apps/resources';
import { getUserSettings } from '../../reducers/integrations/resources'
import { getMessageStatuses } from '../../reducers/message-status/resources';
import {
	resetThread,
	toggleConvoLoading,
	setContact,
	setInboxState
} from '../../reducers/inbox/actions';

import { initRoom, leaveRoom } from '../../io';
import newMessageStatuses from './new-message-statuses';
import { evaluateTCPA } from '../../utils/tcpa';
import config from '../../config';
import constants from '../../constants';

import './index.css';

const OPTED_IN_OPTION = 0; 
const OPTED_OUT_OPTION = 1;

const WEBCHAT = 'webchat';
const TWILLIO = 'twilio';
const MESSAGEMEDIA = 'messagemedia';
const NEXMO = 'nexmo';
const MESSENGER = 'messenger';

const DELIVERED = 'delivered';
const YELLOW_MSG_STATUSES = ['accepted', 'buffered'];
const RED_MSG_STATUSES = [null, 'expired', 'failed', 'rejected', 'unknown']

class Threads extends Component {
	componentWillMount() {
		const { id: userId, name, role:userRole, isActiveCompany } = session.get('userData')
		const isAdmin = userRole === config.userRoles.ghAdmin;

		(async () => {
			this.setState({
				threads: [],
				isLoading: true,
				notifDis: true,
				notifCount: 0,
				inviteMsg: '',
				replyMsg: '',
				openModal: false,
				openOptions: false,
				selectTmpl: null,
				expanded: true,
				tmpls: [],
				showSnackBar: false,
				snackBarMessage: '',
				pageStart: 1,
				hasMore: true,
				resetPage: false,
				moduleGroups: [],
				calendarModuleGroups: null,
				moduleGroup: null,
				openModGroupsDialog: false,
				showNoCalendarDialog: false,
				username: '',
				currentScrollPos: 0,
				prevHeight: 0,
				hasNewMessage: false,
				isSendingMessage: false,
				delSchedMsgDialog: false,
				delSchedId: null,
				msgInfoDialog: false,
				msgInfoData: {},
				messageStatuses: [],
				cursorPosition: 0,
				// check if user already has isActiveCompany flag (need to re-login) and is it active/not
				isInactiveCompany: isAdmin ? false : (!_.isUndefined(isActiveCompany) && !isActiveCompany)
			});

			const { id: userId, name,companyId } = session.get('userData');
			this.props.initRoom(userId);

			let moduleGroups = await getModuleGroupsByCompany(companyId);
			moduleGroups = moduleGroups.data;

			let calendarModuleGroups = await getDefaultCalendarModuleGroups();
			calendarModuleGroups=calendarModuleGroups.data;
  
			let settings = await getUserSettings();
			settings = settings.data;
			let inviteMessage = constants.inviteMessage;
			
			if(settings) {
				inviteMessage = settings.inviteMsg
			}

			let messageStatuses = await getMessageStatuses();
			
			messageStatuses = [...messageStatuses.data, ...newMessageStatuses.statuses];
			
			this.setState({ 
				inviteMsg: inviteMessage,
				moduleGroups, 
				calendarModuleGroups, 
				username: name,
				messageStatuses,
				// check if user already has isActiveCompany flag (need to re-login) and is it active/not
				isLoading: (!_.isUndefined(isActiveCompany) && !isActiveCompany)
			});

		})();
	}

	componentWillReceiveProps(nextProps) {
		const { contact, newThread, newMsgThread, selectedCompanyData } = nextProps;
		const prevContact = this.props.contact;
		const { role :userRole } = session.get('userData')
		const isAdmin = userRole === config.userRoles.ghAdmin;

		if(newMsgThread && newMsgThread.conversation.contact_id!==contact.id){
			//do nothing
			return;
		}
		
		if(isAdmin) {
			this.setState({ isInactiveCompany: false })

			if(!_.isEmpty(selectedCompanyData) && !selectedCompanyData.active) {
				this.setState({ isInactiveCompany: true })
			}
		}

		// create socket room for real time statuses
		// leave room of the previous contact before creating another room
		if(
			!_.isEmpty(prevContact) && 
			!_.isEmpty(contact) &&
			prevContact.id !== contact.id
		) {
			leaveRoom(prevContact.id);
		}

		if(contact) {
			this.props.initRoom(contact.id);
		}

		let { threads } = this.state;

		let scrollPos = this.getScrollPosition();
		if (
			newMsgThread &&
			contact &&
			contact.id === newMsgThread.conversation.contact_id
		) {
			const threadIndex = _.findIndex(threads, { id: newMsgThread.id });

			if (threadIndex === -1) {
				this.setState({ 
					threads: [newMsgThread].concat(threads), 
					// show new message chip only when there is a scrollbar
					hasNewMessage: this.handleHasNewMessage()
				});
			} else {
				threads.splice(threadIndex, 1);
				threads.splice(0, 0, newMsgThread);

				this.setState({ threads });
			}

			// this.scrollBottom();
			this.props.setInboxState({ newMsgThread: null });
		}

		if (!nextProps.threadsLoading) {
			this.setState({
				isLoading: false
			});
		}

		if (nextProps.convoLoading) {
			this.setState({
				threads: [],
				notifCount: 0,
				notifDis: true,
				isLoading: true,
				replyMsg: ''
			});
		}

		if (_.isEmpty(contact)) {
			this.setState({
				threads: [],
				notifCount: 0,
				notifDis: true,
				replyMsg: '',
				isLoading: false
			});
			if (prevContact) {
				leaveRoom(prevContact.id);
			}
		} else {
			this.fromExpand = false;
			const { contact: currentSelectedContact } = this.state;
			
			this.setState({
				notifCount: 0,
				notifDis: true,
			});
		
			(async () => {
				await this.setState({ threads: [], isLoading: true });

				const { pageStart } = this.state;
				let threads = await inboxRsc.getConvoThreads(
					contact.id,
					`page=${pageStart}`
				);
				threads = threads.data;
				let templates = await inboxRsc.getTemplates();
				templates = templates.data;
				
				if (!currentSelectedContact) {
					// get threads on initial render
					this.setState({ threads });
				} else {
					if (currentSelectedContact && currentSelectedContact.id !== contact.id) {
						// when the user selects another convo
						this.setState({
							contact,
							threads,
							tmpls: templates,
							isLoading: false,
							resetPage: true,
							hasNewMessage: false,
							hasMore: threads.length > 0,
							currentScrollPos: 0,
							prevHeight: 0,
							replyMsg: '',
						});
						return this.scrollBottom();
					} else if ( 
						(currentSelectedContact && newMsgThread) && 
						(currentSelectedContact.id !== newMsgThread.conversation.contact_id)
					) {
						// Don't update threads state if the incoming message 
						// doesn't belong to the current contact
						return this.setState({
							contact,
							isLoading: false,
							resetPage: false,
							hasNewMessage: false,
						});
					}

					// Current contact and has incoming threads
					return this.setState({
						threads,
						hasMore: threads.length > 0,
						isLoading: false,
						hasNewMessage: false,
					});
					  
				}
				this.setState({
					threads,
					tmpls: templates,
					isLoading: false,
					hasMore: threads.length > 0,
					resetPage: true,
					currentScrollPos: 0,
					prevHeight: 0,
				});
				this.scrollBottom();
			})();
		}

		if (newThread) {
			// TODO: add notification
		}

		this.setState({ contact });
	}

	componentWillUnmount() {
		this.props.setContact({});
		const { contact } = this.props;
		if (contact) {
			leaveRoom(contact.id);
		}
	}

	componentDidUpdate() {
		if (this.state.contact && !this.fromExpand) {
			this.scrollBottom();
			this.fromExpand = false;
		}

		if(this.state.msgInfoDialog) {
			return this.changeThreadBodyMargin(this.state.expanded, 500, true, true);
		}

		if (this.state.hasNewMessage) {
			this.changeThreadBodyMargin(true, 500, true);
		} else {
			this.changeThreadBodyMargin(true, 500);
		}
	}

	handleOnChange = () => event => {
		this.setState({
			cursorPosition: event.target.selectionStart,
			replyMsg: event.target.value
		});
	};

	quickSend = type => async () => {
		const { moduleGroups } = this.state;

		if (type === 'interview-scheduling') {
			mixpanel.track('inbox:interview scheduling');

			let {
				isLoading,
				contact,
				threads,
				pageStart
			} = this.state;
				
			if(!isLoading){
				//check that user has intergrated calendar
				let userApp = await checkUserGroupDefault('calendar');
				userApp = userApp.data;

				if (!userApp.length) {
					return this.setState({ showNoCalendarDialog: true });
				}

				let mobile = _.find(contact.contactdetails, { field: 'mobile' }) || {
					value: ''
				};
				if (!mobile) {
					return this.setState({
						showSnackBar: true,
						snackBarMessage: 'Contact does not have a mobile number'
					});
				}
				mobile = mobile.value;

				const data = {
					to: contact.mobile,
					contactId: contact.id,
				};
	
				this.setState({
					isSendingMessage: true,
					showSnackBar: true,
					snackBarMessage: 'Message is being sent.',
				});
	
				try {
					await inboxRsc.sendInterviewScheduling(data);
					threads = await inboxRsc.getConvoThreads(
						contact.id,
						`page=${pageStart}`
					);
					threads = threads.data;
	
					mixpanel.track('inbox:send message', { data });
	
					this.setState({
						replyMsg: '',
						threads,
						moduleGroup: null,
						isSendingMessage: false,
						showSnackBar: true,
						snackBarMessage: 'Message successfully sent.',
					});
				} catch (error) {
					this.setState({
						showSnackBar: true,
						snackBarMessage: error.message,
						moduleGroup: null,
						replyMsg: '',
						isSendingMessage: false,
					});
				}
			}			
		}
	};

	handleSendMsg = async event => {
		if (event) {
			event.preventDefault();
		}

		let {
			isLoading,
			replyMsg,
			contact,
			threads,
			pageStart,
			moduleGroup
		} = this.state;

		if (!isLoading && replyMsg) {
			let mobile = _.find(contact.contactdetails, { field: 'mobile' }) || {
				value: ''
			};
			if (!mobile) {
				return this.setState({
					showSnackBar: true,
					snackBarMessage: 'Contact does not have a mobile number'
				});
			}
			mobile = mobile.value;

			// let [thread] = threads;

			if (!moduleGroup) {
				moduleGroup = '';
			}

			const data = {
				to: mobile,
				body: `${replyMsg}`,
				sendType: 'reply',
				//botmapId: thread.conversation.botmap_id,
				contactId: contact.id,
				moduleGroup
			};

			if(threads.length > 0){
				let [thread] = threads;
				data.botmapId = thread.conversation.botmap_id;
			}

			this.setState({
				isSendingMessage: true,
				showSnackBar: true,
				snackBarMessage: 'Message is being sent.',
			});

			try {
				await inboxRsc.sendReply(data);

				threads = await inboxRsc.getConvoThreads(
					contact.id,
					`page=${pageStart}`
				);
				threads = threads.data;

				mixpanel.track('inbox:send message', { data });

				this.setState({
					replyMsg: '',
					threads,
					moduleGroup: null,
					isSendingMessage: false,
					showSnackBar: true,
					snackBarMessage: 'Message successfully sent.',
				});
			} catch (error) {
				this.setState({
					showSnackBar: true,
					snackBarMessage: error.message,
					moduleGroup: null,
					replyMsg: '',
					isSendingMessage: false,
				});
			}
		}
	};

	scrollBottom = isNotif => {
		const bodyEl = document.querySelector('.thread-body');
		if (!bodyEl) {
			return;
		}

		if (isNotif) {
			this.setState({
				notifDis: true,
				notifCount: 0
			});
		}

		bodyEl.scrollTop = bodyEl.scrollHeight;
	};

	getTime = date => {
		const currentDay = Moment().format('D M YYYY');
		const lastConvoDay = Moment(date).format('D M YYYY');
		const dateYearBefore = date ? Moment(date).isBefore(Moment(), 'year') : null;
		const minutesDiff = date ? Moment().diff(Moment(date), 'minutes') : 0;
		const secondsDiff = date ? Moment().diff(Moment(date), 'seconds') : 0;

		// format if message was sent less than a minute
		if(secondsDiff < 60) {
			return `${secondsDiff} sec${secondsDiff > 1 ? 's' : ''} ago`;
		}

		// format if message was sent less than an hour
		if(minutesDiff < 60) {
			return `${minutesDiff} min${minutesDiff > 1 ? 's' : ''} ago`;
		}

		// format if message is sent within the day
		if (currentDay === lastConvoDay) {
			return date ? Moment(date).format('h:mm A') : null;
		}

		// format if message was sent from previous years
		if(dateYearBefore) {
			return Moment(date).format('MMM D, YYYY h:mm A');
		}

		return date ? Moment(date).format('MMM D h:mm A') : null;
	};

	showTemplates = () => {
		mixpanel.track('inbox:view templates');

		this.setState({
			openModal: !this.state.openModal,
			openOptions: false
		});
	}

	showOptions = event => {
		this.setState({
			openOptions: !this.state.openOptions,
			anchorEl: event.currentTarget
		});
	};

	handleClose = () => {
		mixpanel.track('inbox:close view templates');

		this.setState({
			openModal: false,
			selectTmpl: null
		});
	}

	handleSubmitTmpl = () => {
		const tmpl = _.find(this.state.tmpls, { id: this.state.selectTmpl });

		const regExp = /{{([\s\S]+?)}}/g;
		const match = tmpl.details.match(regExp);
		let trimMatch = [];

		let output = tmpl.details;
		if (match && match.length) {
			trimMatch = _.map(match, item => item.slice(2, item.length - 2).trim());

			const { contact } = this.state;
			const { companyName: companyname, name, username } = session.get(
				'userData'
			);

			contact.contactdetails.push(
				{ field: 'companyname', value: companyname },
				{ field: 'recruitername', value: name },
				{ field: 'recruiterusername', value: username }
			);

			const contactdetails = _.filter(contact.contactdetails, cd => {
				return trimMatch.includes(cd.field);
			});

			const templateData = {};
			trimMatch.forEach(match => {
				templateData[match] = '';
			});

			contactdetails.forEach(detail => {
				templateData[detail.field] = detail.value;
			});

			_.templateSettings.interpolate = regExp;
			const compiled = _.template(output);

			output = compiled(templateData);
		}

		mixpanel.track(
			'inbox:select template', { data: { replyMessage: output } }
		);

		this.setState({
			selectTmpl: null,
			openModal: false,
			replyMsg: output
		});
	};

	changeThreadBodyMargin = (expanded, delay = 50, hasMessage, fromMsgInfo) => {
		setTimeout(() => {
			const { currentScrollPos, prevHeight } = this.state;
			const thHead = document.querySelector('.thread-header');
			const thBody = document.querySelector('.thread-body');

			if (thHead) {
				const thHeadHeight = thHead.clientHeight;

				if (expanded) {
					thBody.style.paddingTop = `${thHeadHeight - 120}px`;
				} else {
					thBody.style.marginTop = 'unset';
				}
			}

			// Retains the scroll position of last loaded thread
			if (!hasMessage) {
				const currentHeight = thBody.scrollHeight;
				const prevLastThread = currentHeight - (currentScrollPos + prevHeight);
				thBody.scrollTop = prevLastThread;
			} else if (fromMsgInfo) {
				// retain the position on where the scroll stopped
				return;
			} else {
				// Retains the scroll position of current convo when there is a new message
				this.scrollTo(currentScrollPos)
			}
		}, delay);
	};

	handleExpandChange = expanded => {
		this.fromExpand = true;
		this.setState({ expanded: expanded });

		this.changeThreadBodyMargin(expanded);
	};

	templateChange = (event, id) => this.setState({ selectTmpl: id });

	handleSnackBarClose = () =>
		this.setState({
			showSnackBar: false,
			snackBarMessage: ''
		});

	parseNewLine = (items, index, isUnderWrapper) => {
		const msgItemArr = [];
		const msgOutput = [];

		items.map((item, index) => {
			msgItemArr.push(
				<span key={index}>
					{item}
					<br />
				</span>
			);
		});

		msgOutput.push(
			<div key={index || 0} className="thread-row-msg">
				{msgItemArr}
			</div>
		);
		return msgOutput;
	};

	closeScheduledMsgDialog = () => {
		mixpanel.track('delete sched msg dialog:close');
		this.setState({
			delSchedMsgDialog: false,
			delSchedId: null
		})
	}
	
	handleDeleteSchedMsg = async () => {
		let {threads} = this.state
		const id = this.state.delSchedId
		
		mixpanel.track('scheduled message:delete');
		await deleteScheduledMessage(id)
		_.remove(threads,{id})
		this.setState({threads})
		this.closeScheduledMsgDialog()
	}

	constructScheduledMessage = (msg, thread) => {
		const { created_at,id} = thread
		const msgOutput = [];
		
		msgOutput.push(
			<div className="sched-msg-wrapper">
				<div className="sched-msg-header">
					<Chip className="sched-msg-timer">
						<ImageTimer style={{ marginRight: 5, fontSize: 12 }} />
						<span>
							{Moment(created_at).calendar()}
						</span>
					</Chip>
				</div>
				{msg}
				<div className="sched-msg-footer">
					<IconButton
						iconStyle={{ height: 16 }}
						onClick={()=>{
							mixpanel.track('delete sched msg dialog:open');
							this.setState({
								delSchedMsgDialog: true,
								delSchedId: id
							})
						}}
					>
						<DeleteIcon />
					</IconButton>
				</div>
			</div>
		)

		return msgOutput;

	}

	openMsgInfoDialog = thread => {
		mixpanel.track('Msg Info dialog:open');
		const { contact, messageStatuses } = this.state;

		const {
			direction,
			message_status,
			provider_id,
			provider_code,
			updated_at,
			to, 
			from,
			conversation: { botmap: { type: provider, default: defaultBot } },
			user,
			campaign,
		} = thread;
		let message_desc = "";
		const isNexmo = provider === NEXMO;

		// retain maybe will be used in the future
		if(provider_code && provider === NEXMO) {
			const filtered = messageStatuses.filter(status => status.provider_code === provider_code);

			if(filtered.length) {
				message_desc = filtered[0].provider_description
			}
		}

		const getContact = () => {
			// Message is from 1-1 texting
			if (user) return user.name

			// Messsage is from Campaign
			if (campaign) return campaign.name

			// Sender is from ABT
			if(isNexmo && !defaultBot) return "Apply by Text"

			return "Virtual Agent"
		}

		const constructedData = {
			contact_name: contact.name || '',
			gh_contact: getContact(),
			contact_num: format.forceFormat(to),
			sender_num: format.forceFormat(from),
			msg_timestamp: Moment(updated_at).format('MMMM D, YYYY - hh:mm:ss.SSS A'), // include miliseconds
			message_status: [WEBCHAT, MESSENGER, TWILLIO].includes(provider)  ? DELIVERED : message_status || "Unknown",
			provider,
			provider_id,
			provider_code,
			message_desc,
			direction
		}

		this.setState({
			msgInfoDialog: true,
			msgInfoData: constructedData
		})

		this.changeThreadBodyMargin(this.state.expanded, 500, true, true);
	}

	closeMsgInfoDialog = () => {
		mixpanel.track('Msg Info dialog:close');
		this.setState({
			msgInfoDialog: false,
			msgInfoData: {}
		})
	}

	filterMobile = applicant => {
		let applicantClone = {
			...applicant
		};

		if (Object.keys(applicantClone).length) {
			if (applicantClone.app_mobile.includes('+')) {
				return applicantClone;
			}
			return (applicantClone.app_mobile = '');
		}
		return true;
	};

	loadMore = async (page, scrollHeight) => {
		await this.setState({ isLoading: true });
		const { contact, threads, hasMore } = this.state;

		if (hasMore && contact) {
			const threadRows = document.querySelectorAll('.thread-row');

			let pageThreads = await inboxRsc.getConvoThreads(
				contact.id,
				`page=${page}`
			);
			pageThreads = pageThreads.data;

			this.setState({
				threads: threads.concat(pageThreads),
				isLoading: false,
				hasMore: pageThreads.length > 0,
				resetPage: false,
				currentScrollPos: this.maintainScrollPosition(page, threadRows),
				prevHeight: scrollHeight
			});
		} else {
			await this.setState({ isLoading: false });
		}
	};

	maintainScrollPosition = (page, threadRows) => {
		if (page < 1) {
			return 0;
		}
		return threadRows[0].scrollHeight;
	}

	gotoProfile = () => {
		mixpanel.track('inbox:redirect to contact details');
		this.props.history.push(
			`/contacts/${(this.state.contact || { id: '' }).id}`
		);
	}

	handleHasNewMessage = () => {
		// checks if the window is scrollable, then shows the new message chip
		const threadBodyEl = document.querySelector('.thread-body');
		if (threadBodyEl.scrollHeight > threadBodyEl.clientHeight) {
			return true;
		}
		return false;
	}
	
	scrollToNewMessage = () => {
		this.scrollBottom();
		this.setState({ currentScrollPos: 0, hasNewMessage: false });
	}

	scrollTo = (value) => {
		const threadBodyEl = document.querySelector('.thread-body');
		threadBodyEl.scrollTop = value;
	}

	getScrollPosition = () => {
		const threadBodyEl = document.querySelector('.thread-body');
		return threadBodyEl.scrollTop;
	}

	displayMessageStatus = (thread) => {
		const { message_status, provider_id } = thread;

		if(!provider_id) {
			return;
		}

		if (!message_status) {
			return <span>Sending</span>
		}

		if(YELLOW_MSG_STATUSES.includes(message_status)) {
			return <span>Sent</span>
		}

		if(RED_MSG_STATUSES.includes(message_status)) {
			return (
				<span style={{ color: 'rgb(244, 67, 54)'}}>Message could not be sent.</span>
			)
		}
	}

	addMailMerge = (value) => (event) => {
		const { replyMsg, cursorPosition } = this.state;
		mixpanel.track('thread:chip')

		// put mailMerge value where the cursor is located
        this.setState({
			replyMsg:
				replyMsg.substring(0, cursorPosition)
				+ value
				+ replyMsg.substring(cursorPosition, replyMsg.length),
			cursorPosition: cursorPosition + value.length
		})
	}

	getCursorPosition = e => {
		const cursorPosition = e.target.selectionStart;
		this.setState({ cursorPosition });
	}

	render() {
		const styles = {
			filter: {
				color: '#FFF'
			},
			avatar: {
				float: 'left'
			},
			refresh: {
				marginLeft: '50%',
				display: 'inline-block',
				position: 'absolute',
				display: this.state.isLoading ? 'inline-block' : 'none'
			},
			sadIcon: {
				width: 90,
				height: 90,
				color: '#F0F0F0'
			},
			iconBtn: {
				paddingRight: 0,
				marginRight: '-15px'
			},
			card: {
				backgroundColor: '#F0F0F0',
				boxShadow: 'none'
			},
			cardHeader: {
				padding: '0 0 0 20px',
			},
			cardText: {
				padding: '0 0 0 8px',
			},
			chip: {
				margin: 4
			},
			actions: {
				margin: 12
			},
			badge: {
				zIndex: 2
			}
		};

		const iconType = {
			messenger: (
				<div
					className="pull-right"
					style={{
						display: 'inline-block',
						color: '#1DAFFC',
						marginRight: 10,
						fontSize: '8px'
					}}
				>
					<i className="fab fa-facebook-messenger fa-2x" />
				</div>
			),
			webchat: (
				<div
					className="pull-right"
					style={{
						display: 'inline-block',
						marginRight: 7
					}}
				>
					<img src="/assets/images/bluechat.png" className="thread-icon" />
				</div>
			),
			twilio: (
				<div
					className="pull-right"
					style={{ display: 'inline-block', marginRight: 10 }}
				>
					<img src="/assets/images/greensms.png" className="thread-icon" />
				</div>
			),
			nexmo: (
				<div
					className="pull-right"
					style={{ display: 'inline-block', marginRight: 10 }}
				>
					<img src="/assets/images/greensms.png" className="thread-icon" />
				</div>
			),
			messagemedia: (
				<div
					className="pull-right"
					style={{ display: 'inline-block', marginRight: 10 }}
				>
					<img src="/assets/images/greensms.png" className="thread-icon" />
				</div>
			)
		};

		let SelectableList = makeSelectable(List);

		const { moduleGroups, moduleGroup } = this.state;

		const { companyId } = session.get('userData');
		let menuOptions = [
			<MenuItem key={0} primaryText="Templates" onClick={this.showTemplates} />,
			<MenuItem
				key={1}
				primaryText="Automated Conversations"
				onClick={async () => {
					let moduleGroups = await getModuleGroupsByCompany(companyId);
					moduleGroups = moduleGroups.data;

					this.setState({
						openModGroupsDialog: true,
						moduleGroups,
						openOptions: false,
					});
				}}
			/>,
		];
		let items = [];
		let meta = [];
		let tmplDialog = [];
		let notifCont = [];
		const actions = [
			<RaisedButton
				label="Cancel"
				primary={true}
				onClick={this.handleClose}
				style={styles.actions}
			/>,
			<RaisedButton
				label="Submit"
				primary={true}
				onClick={this.handleSubmitTmpl}
				disabled={this.state.tmpls.length === 0}
				style={styles.actions}
			/>
		];
		const noIntegrationActions = [
			<RaisedButton
				label="Close"
				onClick={() => this.setState({ showNoCalendarDialog: false })}
				style={styles.actions}
			/>
		];
		const modGroupActions = [
			<RaisedButton
				label="Cancel"
				secondary={true}
				onClick={() =>
					this.setState({ openModGroupsDialog: false, moduleGroup: null })
				}
				style={{ marginRight: 8 }}
			/>,
			<RaisedButton
				label="Select"
				primary={true}
				onClick={() => {
					let { moduleGroup, moduleGroups } = this.state;

					moduleGroup = _.find(moduleGroups, { id: moduleGroup });

					if (moduleGroup.module) {
						this.setState({
							replyMsg: moduleGroup.module.response,
							openModGroupsDialog: false
						});
					} else {
						this.setState({
							replyMsg: '',
							openModGroupsDialog: false,
							showSnackBar: true,
							snackBarMessage: 'Module group does not have a start module',
							moduleGroup: null
						});
					}
				}}
				disabled={moduleGroups.length === 0}
			/>
		];

		const deleteActions = [
			<RaisedButton
				label="Cancel"
				primary={true}
				onClick={this.closeScheduledMsgDialog}
				style={styles.actions}
			/>,
			<RaisedButton
				label="Submit"
				primary={true}
				onClick={this.handleDeleteSchedMsg}
				style={styles.actions}
			/>
		]

		const msgInfoActions = [
			<FlatButton
				label="Close"
				primary={true}
				onClick={this.closeMsgInfoDialog}
				className="msg-info-btn"
				style={{
					margin: '0 15px 10px',
					minWidth: '55px',
					height: '20px',
					lineHeight: '20px'
				}}
				labelStyle={{
					fontSize: '12px',
					padding: 0
				}}
			/>
		]

		const excludeKeys = [
			'Opted-In'
		];

		if (this.props.isInbox && this.state.contact) {
			const { contact } = this.state;
			// f278bf6c-8393-4276-a86e-05d264530f3d for sms
			// 7d59c9cc-5efe-4f79-bf6a-c590ec3dfda3 for webchat
			let lastname = (
				_.find(contact.contactdetails, { field: 'lastname' }) || { value: '' }
			).value;

			let init = {
				Email: '',
				'Shift Preference': '',
				'Dept. Interest': '',
				'Emp. Type': ''
			};

			if (contact.contactdetails) {
				contact.contactdetails.forEach((item, index) => {
					this.hasContact = true;

					switch (item.field.toLowerCase()) {
						case 'email':
							const email = item.value.trim();
							if (validator.isEmail(email)) {
								init['Email'] = email;
							} else {
								delete init['Email'];
							}
							break;
						case 'shift':
							init['Shift Req'] = item.value;
							break;
						case 'interest':
							init['Dept. Req'] = item.value;
							break;
						case 'employmenttype':
							init['EmpType'] = item.value;
							break;
						case 'location':
						case 'storepreferences':
						case 'storepreference':
						case 'storepref':
							init['Preferred Location'] = item.value;
							break;
						case 'agreement':
							/*
							const dateFormat = 'MMM D, YYYY';
							const optedIn = contact.contactdetails.find(({ field }) => 
								field.toLowerCase() === 'optedindate'
							);
							const optedOut = contact.contactdetails.find(({ field }) => 
								field.toLowerCase() === 'optedoutdate'
							);
							const optedInDate = Moment(optedIn && optedIn.value || null);
							const optedOutDate = Moment(optedOut && optedOut.value || null);
							if (!optedInDate.isValid() && !optedOutDate.isValid()) {
								break;
							} else if (
								optedInDate.isValid() &&
								item.value.trim().toLowerCase() === 'yes' &&
								!optedOutDate.isValid()
							) {
								init['Opted-In'] = optedInDate.format(dateFormat);
							} else {
								init['Opted-Out'] = optedOutDate.format(dateFormat);
							}
							*/

							let fields = {};

							for(const detail of contact.contactdetails) {
								fields[detail.field] = detail.value;
							}

							let isTCPA = evaluateTCPA(fields);

							const dateFormat = 'MMM D, YYYY';

							if(isTCPA == OPTED_IN_OPTION) {
								init['Opted-In'] = Moment(fields.optedInDate).format(dateFormat);
							} else {
								init['Opted-Out'] = Moment(fields.optedOutDate).format(dateFormat);
							}							
							
							break;
						default:
							// statements_def
							break;
					}
				});
			}

			Object.keys(init).map((key, index) => {
				if (excludeKeys.includes(key)) return;
				if (init[key]) {
					this.hasContact = true;
					meta.push(
						<Chip key={index} style={styles.chip}>
							{key} : <strong>{init[key]}</strong>
						</Chip>
					);
				}
			});
		}

		let carouselIndex = 0;

		const { threads } = this.state;
		const threadCount = threads.length;
		if (threadCount) {
			_.orderBy(threads, ['created_at'], ['asc']).forEach((thread, index) => {
				const activeRow =
					thread.direction === 'inbound' ? 'pull-left' : 'pull-right';
				let classRow = 'thread-row ' + activeRow;
				const activeTime = thread.direction === 'inbound' ? '' : 'pull-right';
				const classTime = `thread-row-timestamp ${activeTime}`;
				const msgParse = jsonParse(thread.message);
				let msgWrapper = [];
				let rowWrapper = [];

				if(thread.direction === 'scheduled') {
					classRow = `${classRow} scheduled`;
				}

				if (threadCount === index + 1) {
					classRow = `${classRow} last-thread`;
				}

				const obj = {
					inbound: () => {
						let msgStr = msgParse.toString();
						msgWrapper = this.parseNewLine(msgStr.split('\n'));
					},
					outbound: () => {
						if (['string', 'number'].includes(typeof msgParse)) {
							return (
								msgWrapper = this.parseNewLine(msgParse.toString().split('\n')));
						}

						arrayLoop(msgParse, (msgItem, index) => {
							const item = jsonParse(msgItem);

							if (typeof item === 'string') {
								rowWrapper = [
									...rowWrapper,
									...this.parseNewLine(
										msgItem.split('\n'),
										rowWrapper.length,
										true
									)
								];
								return;
							}

							// handle cards here
							if (item.card) {
								msgWrapper.push(
									<Carousel key={-1} cards={item.card} index={carouselIndex} />
								);
								carouselIndex++;
							}
						});
					},
					scheduled: () => {
						if (['string', 'number'].includes(typeof msgParse)) {
							msgWrapper = this.parseNewLine(msgParse.toString().split('\n'))

							msgWrapper = this.constructScheduledMessage(msgWrapper, thread)

							return (msgWrapper);
						}
					}
				};

				obj[thread.direction]();
				msgWrapper = [
					...[
						<div key={-3} className="thread-row-msg-wrapper pull-right">
							{rowWrapper}
						</div>
					],
					...msgWrapper
				];

				const { contact } = this.state;
				const nameAbbre = (
					contact ? contact.name.toUpperCase().match(/\b(\w)/g) || [] : []
				).join(' ');

				const { botmap: { type: provider, default: defaultBot } } = thread.conversation;
				const { user, message_status, campaign, provider_id } = thread;
				const isNexmo = provider === NEXMO;
				const isMsgMedia = provider === MESSAGEMEDIA;
				let addDetails;
				let senderName = 'Virtual Agent';

				/**
				 *	Legends: 
				 *		green - delivered
				 		yellow - accepted, buffered
						red - expired, failed, rejected, unkown, opted-out

					NOTE: GH prevents user to send message to opted-out contacts by default

					TODO: REMOVE ALL ICON RELATED IF APPROVED
				 */
				const getIconColor = () => {
					// webchat outbound messages are always delivered
					if([WEBCHAT, MESSENGER, TWILLIO].includes(provider)) {
						return green500;
					}

					// for Nexmo
					if(isNexmo && YELLOW_MSG_STATUSES.includes(message_status)) {
						return green500;
					}

					// for Nexmo
					if(isNexmo && RED_MSG_STATUSES.includes(message_status)) {
						return red500;
					}

					// return red if message_status of messagemedia is not delivered
					if(isMsgMedia && message_status !== DELIVERED) {
						return red500;
					}

					return green500;
				}

				const iconButton = color => {
					return (
						<IconButton
								className="message-status-btn"
								onClick={() => this.openMsgInfoDialog(thread)}
							>
							<ActionInfo
								color={color}
								className="message-status-btn-icon" 
							/>
						</IconButton>
					)
				}

				// Message is from 1-1 texting
				if (user) {
					senderName = user.name
				}

				// Messsage is from Campaign
				if (campaign) {
					senderName = campaign.name
				}

				// Sender is from ABT
				if(isNexmo && !defaultBot) {
					senderName = "Apply by Text"
				}

				/**
				 * Display sendername and timestamp for delivered messages
				 * or among webchat, twilio, or messenger
				 * 
				 * messagemedia = message status
				 * nexmo = provider_code
				 * twilio, webchat, messenger = always delivered
				 */
				const getDetailContent = () => {

					// for old/bad data - returns 'sending' if not caught
					if([NEXMO, MESSAGEMEDIA].includes(provider) && !provider_id) {
						return ''
					}

					if(
						(message_status === DELIVERED) ||
						([WEBCHAT, MESSENGER, TWILLIO].includes(provider))
					) {
						return (
							<span>
								<span className="thread-name" key={index}>
									{senderName}
								</span>
								<span
									onClick={() => this.openMsgInfoDialog(thread)}
								>
									{this.getTime(thread.updated_at)}
								</span>
							</span>
						)
					} else {
						return (
							<span
								style={{ marginLeft: 5 }}
								onClick={() => this.openMsgInfoDialog(thread)}
							>
								{this.displayMessageStatus(thread)}
							</span>
						)
					}
				}

				if (thread.direction === 'inbound') {
					addDetails = [
						<div className="message-details">
							<span
								onClick={() => this.openMsgInfoDialog(thread)}
							>
								{this.getTime(thread.updated_at)}
							</span>
							<span className="thread-name" key={index}>
								{this.state.contact ? this.state.contact.name : ''}
							</span>
							{/* {iconButton(green500)} */}
						</div>
					];
				} else if (thread.direction === 'scheduled'){
					addDetails = [
						<span className="thread-name" key={index}>
							{senderName}
						</span>,
					];
				} else {
					addDetails = [
						<div className="message-details">
							{/* {iconButton(getIconColor())} */}
							{getDetailContent()}
						</div>
					];
				}

				items.push(
					<div key={index} className={classRow}>
						{msgWrapper}
						<div className={classTime}>
							{addDetails}
						</div>
					</div>
				);
			});
		}

		this.state.tmpls.forEach((item, index) => {
			tmplDialog.push(
				<ListItem
					key={index}
					value={item.id}
					primaryText={item.name}
					secondaryText={item.details}
				/>
			);
		});

		const modGrps = moduleGroups.map((item, index) => {
			return <ListItem key={index} value={item.id} primaryText={item.name} />;
		});

		if (!this.state.notifDis) {
			notifCont.push(
				<Badge
					key={1}
					primary={true}
					badgeContent={this.state.notifCount}
					badgeStyle={{ top: 20, right: 20 }}
					style={styles.badge}
				>
					<IconButton
						tooltip="Unread Messages"
						disabled={this.state.notifDis}
						onClick={() => this.scrollBottom(true)}
					>
						<NotificationsIcon color={green500} />
					</IconButton>
				</Badge>
			);
		}

		const MessageInfoBody = () => {
			const { msgInfoData } = this.state;

			const msgType = {
				inbound: "received",
				outbound: "sent"
			}

			const providerList = {
				nexmo: "Nexmo",
				messagemedia: "MessageMedia",
				webchat: "Web Chat"
			}

			const {
				contact_name,
				gh_contact,
				contact_num,
				sender_num,
				msg_timestamp,
				message_status,
				provider,
				message_desc,
				direction
			} = msgInfoData

			const outboundMsg = direction === 'outbound'

			return (
				<div className='msg-info-body'>
					<p><strong>To: </strong>{outboundMsg ? `${contact_name}` : `${gh_contact}`} - {contact_num}</p>
					<p><strong>From: </strong>{!outboundMsg ? `${contact_name}` : `${gh_contact}`} - {sender_num}</p>
					<p><strong>Message {msgType[direction]}: </strong>{msg_timestamp}</p>
					{outboundMsg && provider ? <p><strong>Provider: </strong>{providerList[provider]}</p> : ''}
					{outboundMsg && message_status ? 
						<p>
							<strong>Message Status: </strong>
							<span style={{ textTransform: 'capitalize'}}>{message_status}</span>
						</p>
					: ''}
					{message_desc ? <p><strong>Status details: </strong>{message_desc}.</p> : ''}
				</div>
			)
		}

		const { contact } = this.state;
		let nameAbbre = '';
		if (contact && !_.isEmpty(contact)) {
			nameAbbre = (
				(contact || { name: '' }).name.toUpperCase().match(/\b(\w)/g) || []
			).join(' ');
		}

		let mobile = '';
		if (contact) {
			mobile = (
				_.find(contact.contactdetails, { field: 'mobile' }) || { value: '' }
			).value;
			mobile = format.forceFormat(mobile);
		}
		const headerInbox = (
			!this.state.isInactiveCompany ? 
				<div className="thread-header">
					<div className="thread-header-col pull-right">
						<div className="thread-header-notif pull-right">{notifCont}</div>
						<Card
							expanded={this.state.expanded && this.hasContact}
							onExpandChange={this.handleExpandChange}
							style={styles.card}
						>
							<CardHeader
								title={
									<span onClick={this.gotoProfile} style={{ cursor: 'pointer' }}>
										{(contact || { name: '' }).name}
									</span>
								}
								subtitle={mobile}
								showExpandableButton={this.hasContact}
								style={styles.cardHeader}
							/>
							<CardText expandable={true} style={styles.cardText}>
								<div
									style={{ display: 'flex', flexWrap: 'wrap', }}
								>
									{meta}
								</div>
							</CardText>
						</Card>
					</div>
				</div> :
				''
		);

		const header = this.props.isInbox ? headerInbox : '';

		const mailMerge = [
			{
				name: 'First Name',
				value: '{{firstname}}'
			},
			{
				name: 'Last Name',
				value: '{{lastname}}'
			},
			{
				name: 'Recruiter Name',
				value: session.get('userData').name,
			},
			{
				name: 'Brand Name',
				value: session.get('userData').companyName,
			},
		];

		const mailMergeChips = mailMerge.map(mail => {
			return (
				<Chip
					key={mail.value}
					style={{ margin: 5 }}
					onClick={this.addMailMerge(mail.value)}
				>
					<strong>{mail.name}</strong>
				</Chip>
			);
		});

		return (
			<Col
				xs={12}
				sm={this.props.smWidth}
				className="thread-wrapper no-padding"
			>
				<Snackbar
					open={this.state.showSnackBar}
					message={this.state.snackBarMessage}
					autoHideDuration={4000}
					onRequestClose={this.handleSnackBarClose}
				/>
				{header}
				<div className="thread-body">
					<InfiniteScroll
						pageStart={this.state.pageStart}
						loadMore={this.loadMore}
						hasMore={this.state.hasMore}
						isReverse={true}
						useWindow={false}
						initialLoad={false}
						isLoading={this.state.isLoading}
						resetPage={this.state.resetPage}
						loader={
							<div className="loader" key={0}>
								<RefreshIndicator
									key={-20}
									size={50}
									left={-25}
									top={100}
									loadingColor="#44B535"
									status={'loading'}
									style={styles.refresh}
								/>
							</div>
						}
					>
						{!this.state.isInactiveCompany ? items : 
							<div
								style={{
								position: 'absolute',
								width: '100%',
								marginTop: '20px',
								textAlign: 'center'
								}}
							>
								<strong>Company is inactive.</strong>
							</div>
						}
					</InfiniteScroll>
				</div>
				<div className="thread-footer-wrapper">
					<div className="thread-footer">
						{this.state.hasNewMessage ? (
							<Chip 
							onClick={this.scrollToNewMessage}
							backgroundColor={blue300}
							labelColor='#fff'
							style={{
								position: 'absolute',
								top: '-42px',
								left: '70%',
							}}
							>
								New message
							</Chip>
						): null}
						<IconButton
							className="pull-left"
							onClick={this.showOptions}
							style={styles.iconBtn}
						>
							<MoreIcon />
						</IconButton>
						<div>
							<div style={{
								display: 'inline-block',
								marginLeft: '15px',
							}}>
								<div style={{ display: 'flex', flexWrap: 'wrap', }}>
									{mailMergeChips}
								</div>
							</div>
						</div>
						<form onSubmit={this.handleSendMsg} className="col-sm-11 col-xs-11">
							<div className="thread-footer-textfield">
								<div>
									<TextField
										id="messageTextField"
										value={this.state.replyMsg}
										onChange={this.handleOnChange()}
										autoFocus={true}
										fullWidth={true}
										hintText="Type a message..."
										autoComplete="off"
										multiLine={true}
										rowsMax={4}
										maxLength={constants.maxMessageLength}
										disabled={
											this.state.isSendingMessage ||
											this.state.isLoading ||
											!this.state.contact ||
											moduleGroup !== null ||
											this.state.isInactiveCompany
										}
										onClick={this.getCursorPosition}
										onKeyDown={this.getCursorPosition}
									/>
								</div>
								<div>
									<div
										className="moduleGrpAction"
										style={{ display: moduleGroup ? 'block' : 'none' }}
										onClick={() => {
											this.setState({ moduleGroup: null, replyMsg: '' });
										}}
									>
										<div>
											<CancelIcon
												color="#f44336bf"
												style={{ width: 16, height: 16 }}
											/>
										</div>
										<div className="moduleGrpLabel">Module Group</div>
									</div>
								</div>
							</div>
							<div className="quick-send">
								<IconButton 
									tooltip="Interview Scheduling"
									onClick={this.quickSend('interview-scheduling')}
								>
									<DateRangeIcon />
								</IconButton>
							</div>
							<div className="thread-footer-btn">
								<FloatingActionButton
									mini={true}
									type="submit"
									disabled={
										this.state.isLoading ||
										!this.state.contact ||
										this.state.isSendingMessage
									}
								>
									<SendBtn />
								</FloatingActionButton>
							</div>
						</form>
					</div>
				</div>
				<Popover
					open={this.state.openOptions}
					anchorEl={this.state.anchorEl}
					anchorOrigin={{ horizontal: 'left', vertical: 'top' }}
					targetOrigin={{ horizontal: 'left', vertical: 'top' }}
					onRequestClose={() => this.setState({ openOptions: false })}
				>
					<Menu>{menuOptions}</Menu>
				</Popover>
				<Dialog
					title="Message Templates"
					actions={actions}
					modal={false}
					open={this.state.openModal}
					onRequestClose={() => this.setState({ openModal: false })}
					autoScrollBodyContent={true}
					bodyStyle={{ paddingTop: 10 }}
				>
					<SelectableList
						value={this.state.selectTmpl}
						onChange={this.templateChange}
					>
						{tmplDialog}
					</SelectableList>
				</Dialog>
				<Dialog
					title="Automated Conversations"
					actions={modGroupActions}
					modal={false}
					open={this.state.openModGroupsDialog}
					onRequestClose={() => this.setState({ openModGroupsDialog: false })}
					autoScrollBodyContent={true}
					bodyStyle={{ paddingTop: 10 }}
				>
					<SelectableList
						value={moduleGroup}
						onChange={(event, modGrpId) =>
							this.setState({ moduleGroup: modGrpId })
						}
					>
						{modGrps}
					</SelectableList>
				</Dialog>
				<Dialog
					title="Interview Schedule Integration"
					actions={noIntegrationActions}
					modal={false}
					open={this.state.showNoCalendarDialog}
					onRequestClose={() => this.setState({ showNoCalendarDialog: false })}
					autoScrollBodyContent={true}
				>
					<h4>
						You need to integrate your calendar before being able to use this
						feature.
					</h4>
					<h4>
						Click
						<a
							href="#"
							onClick={e => {
								e.preventDefault();

								this.props.history.replace({ pathname: '/interview-invites', search: '?tab=integrations' });
							}}
						>
							{' '}
							here{' '}
						</a>
						to process integration.
					</h4>
				</Dialog>
				<Dialog
					actions={deleteActions}
					modal={false}
					open={this.state.delSchedMsgDialog}
					onRequestClose={this.closeScheduledMsgDialog}
				>
					<div>
	                	Are you sure you want to delete this scheduled message?
					</div>
				</Dialog>
				<Dialog
					title="Message Information"
					actions={msgInfoActions}
					modal={false}
					open={this.state.msgInfoDialog}
					onRequestClose={this.closeMsgInfoDialog}
					bodyStyle={{ padding: '0 15px' }}
					titleStyle={{
						padding: '10px 15px',
						fontSize: '18px', lineHeight: '24px'
					}}
					contentStyle={{ width: '20%'}}
					overlayStyle={{ backgroundColor: 'rgba(0, 0, 0, 0.1)' }}
					actionsContainerStyle={{ padding: '0' }}
				>
					<MessageInfoBody />
				</Dialog>
			</Col>
		);
	}
}

const mapStateToProps = state => {
	const { contact, newThread, threads, newMsgThread } = state.inbox;
	const { selectedCompanyData } = state.company;

	return { contact, newThread, threads, newMsgThread, selectedCompanyData };
};

const mapDispatchToProps = dispatch => {
	return {
		initRoom(id) {
			return initRoom(id);
		},
		resetThread() {
			dispatch(resetThread());
		},
		toggleConvoLoading(status) {
			dispatch(toggleConvoLoading(status));
		},
		setContact(contact) {
			dispatch(setContact(contact));
		},
		setInboxState(data) {
			dispatch(setInboxState(data));
		}
	};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(Threads);
